var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFavoriteDisable = function SvgIconFavoriteDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "m9.766 16.62.002.002.235.21.23-.203.002-.002c2.218-1.983 3.937-3.522 5.12-4.945C16.52 10.28 17 9.178 17 8.1 17 6.375 15.638 5 13.825 5c-1.034 0-2.043.48-2.69 1.23L10 7.54 8.866 6.23A3.63 3.63 0 0 0 6.175 5C4.362 5 3 6.375 3 8.099c0 1.079.48 2.18 1.646 3.582 1.182 1.422 2.9 2.96 5.12 4.94m1.467 1.127-.563.5a1.01 1.01 0 0 1-1.338-.003l-.565-.504-.007-.007C4.387 13.833 1.5 11.257 1.5 8.1 1.5 5.523 3.557 3.5 6.175 3.5A5.11 5.11 0 0 1 10 5.247 5.112 5.112 0 0 1 13.825 3.5c2.618 0 4.675 2.023 4.675 4.599 0 3.153-2.878 5.725-7.24 9.623z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFavoriteDisable;